import Layout from "@/layout";

export default {
  path: "/driver",
  component: Layout,
  redirect: "/driver/index",
  children: [
    {
      path: "index",
      name: "drivers",
      component: () =>
        import(/* webpackChunkName: "driver-list" */ "@/views/driver"),
      meta: {
        title: "Drivers",
        icon: "drivers-v2",
        keepName: "driversIndex",
        keepAlive: true,
      },
    },
    {
      path: "driverAdd",
      name: "driverAdd",
      component: () =>
        import(/* webpackChunkName: "driver-add" */ "@/views/driver/add"),
      meta: { activeMenu: "/driver/index" },
      hidden: true,
    },
    {
      path: "driverEdit",
      name: "driverEdit",
      component: () =>
        import(/* webpackChunkName: "driver-edit" */ "@/views/driver/edit"),
      meta: { activeMenu: "/driver/index" },
      hidden: true,
    },
    {
      path: "driverDetails",
      name: "driverDetails",
      component: () =>
        import(
          /* webpackChunkName: "driver-details" */ "@/views/driver/details"
        ),
      meta: { activeMenu: "/driver/index" },
      hidden: true,
    },
  ],
};
